import React, { Component } from "react";

import { Card, CardBody, Col, Container, Row } from "reactstrap";

import "react-bootstrap-table2-filter/dist/react-bootstrap-table2-filter.min.css";

//Import Breadcrumb
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import RemoteTable from "../../../components/Common/RemoteTable";
import { getClientsVkList, integrationStateInit } from "../../../store/integration/actions";
import ModifiedMetaTags from '../../../components/ModifiedMetaTags/index';

class ClientsVK extends Component {
  constructor(props) {
    super(props);

    this.state = {
      page: 1,
      sizePerPage: 10,
      filter_name: [],
    };

    this.searchTimer = null;
  }

  componentDidMount() {
    this.props.getClientsVkList({ ...this.props.data, search: null });
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
  }

  componentWillUnmount() {
    this.props.integrationStateInit()
  }

  handleTableChange = (data) => {
      this.props.getClientsVkList(data);
  };

  render() {
    const columns = [
      {
        dataField: "id",
        text: "ID",
        sort: true,
      },
      {
        dataField: "name",
        text: "Name",
        sort: true
      },
      {
        dataField: "day_limit",
        text: "Day limit",
        sort: true,
      },
      {
        dataField: "all_limit",
        text: "All limit",
        sort: true
      },
    ];

    return (
      <React.Fragment>
        <div className="page-content">
        <ModifiedMetaTags title="Clients VK | Mobihunter" />

          <Container fluid>
            <Breadcrumbs title="Dashboard" breadcrumbItem="Clients VK" link="/dashboard"/>
            <Row>
              <Col className="col-12">
                <Card>
                  <CardBody>
                    <RemoteTable
                      onTableChange={this.handleTableChange}
                      columns={columns}
                      data={this.props.data}
                      loading={this.props.loading}
                    >
                    </RemoteTable>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

ClientsVK.propTypes = {
  data: PropTypes.object,
  loading: PropTypes.bool,
  getClientsVkList: PropTypes.func.isRequired,
  integrationStateInit: PropTypes.func.isRequired,
  permissions: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
  data: state.Integration.dataClientVk,
  loading: state.Integration.loading_client_vk,
  permissions: state.User.permissions
});

export default connect(mapStateToProps, { getClientsVkList, integrationStateInit })(
  ClientsVK
);
